var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e5ce4aa20b43de8511bed7cfab973af47b3c2046"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["breitbart-nextjs-web@sentry"]={id:"e5ce4aa20b43de8511bed7cfab973af47b3c2046"};
      